import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useCallback } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { URLS } from '@wix/da-url';
import Modal from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import { useFirstTimeFlag } from '@wix/da-shared-react/pkg/redux/firstTimeFlags/hooks';
import { FirstTimeFlag } from '@wix/da-shared-react/pkg/redux/firstTimeFlags';
import s from './PromptGuidelinesModal.scss';
const PromptGuidelinesModal = (_param)=>{
    var { onConfirm, onRequestClose } = _param, rest = _object_without_properties(_param, [
        "onConfirm",
        "onRequestClose"
    ]);
    const { t } = useTranslation('dreamup');
    const { dropFlag } = useFirstTimeFlag(FirstTimeFlag.IsDreamupPromptGuidelinesNotSeen);
    const handleConfirmClick = useCallback((e)=>{
        dropFlag();
        onConfirm && onConfirm();
        onRequestClose && onRequestClose(e);
    }, [
        dropFlag,
        onRequestClose,
        onConfirm
    ]);
    return /*#__PURE__*/ React.createElement(Modal, _object_spread({
        isOpen: true,
        showFooterBorder: true,
        showHeaderBorder: true,
        className: s['root'],
        heading: t('dreamup.modal.promptGuidelines.heading'),
        footerRight: [
            /*#__PURE__*/ React.createElement(TextButton, {
                key: "cancel",
                size: "large",
                variant: "main",
                onClick: onRequestClose
            }, t('dreamup.modal.promptGuidelines.cancelButton.label')),
            /*#__PURE__*/ React.createElement(BrandedButton, {
                key: "confirm",
                size: 'large',
                variant: 'brand-green',
                onClick: handleConfirmClick
            }, t('dreamup.modal.promptGuidelines.confirmButton.label'))
        ],
        onRequestClose: onRequestClose
    }, rest), /*#__PURE__*/ React.createElement("div", {
        className: s['description']
    }, /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: "dreamup.modal.promptGuidelines.description",
        ns: "dreamup",
        components: {
            p: /*#__PURE__*/ React.createElement("p", null),
            ul: /*#__PURE__*/ React.createElement("ul", null),
            li: /*#__PURE__*/ React.createElement("li", null),
            b: /*#__PURE__*/ React.createElement("b", null),
            /* eslint-disable jsx-a11y/anchor-has-content */ 'dreamup-policy-link': /*#__PURE__*/ React.createElement("a", {
                href: URLS.DREAMUP_POLICY,
                target: "_blank",
                rel: "noreferrer"
            }),
            'terms-of-service-link': /*#__PURE__*/ React.createElement("a", {
                href: URLS.TOS,
                target: "_blank",
                rel: "noreferrer"
            })
        }
    })));
};
PromptGuidelinesModal.displayName = 'PromptGuidelinesModal';
export default PromptGuidelinesModal;

//# sourceMappingURL=PromptGuidelinesModal.js.map